import React from "react";
import Grid from "@material-ui/core/Grid";

import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import LinearProgress from "@material-ui/core/LinearProgress";
import NumberFormat from "react-number-format";
import {InputText} from "primereact/inputtext";
import HeaderScreenPresval from "../../../components/headerScreenPresval";
import ContextMenu from "../../../components/contextMenu";
import Typography from "@material-ui/core/Typography";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {Calendar} from "primereact/calendar";
import {CALENDAR_ES, DATE_FORMAT_CALENDAR} from "../../../utils/constants/Constants";
import {getIconFromMenu} from "../../../utils/icon/IconProcessor"
import {Dropdown} from "primereact/dropdown";
import PropTypes from "prop-types";

const BilateralControlPanelView = ({...props}) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '0%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                {props.messagesGrowl}
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <HeaderScreenPresval headerTitle="Bilaterales \ Tablero de Control"
                                             onExpand={props.clearFilters}
                                             actionSearch={props.getControlPanelLoanList}
                                             menuIcon={getIconFromMenu("Tablero de control ")}>
                            <div className="p-grid">
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Folio" isBold={true}/>
                                    <NumberFormat
                                        name="loanId"
                                        allowNegative={false}
                                        maxLength={9}
                                        thousandSeparator={false}
                                        customInput={InputText}
                                        value={props.filters.loanId}
                                        onChange={props.saveFilters}
                                    />
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Prestamista" isBold={true}/>
                                    <Dropdown name="lenderObj"
                                              filterBy="shortName"
                                              optionLabel="shortName"
                                              placeholder="Seleccione..."
                                              options={props.catLender}
                                              value={props.filters.lenderObj}
                                              onChange={props.saveFilters}
                                    />

                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Prestatario" isBold={true}/>
                                    <Dropdown name="borrowerObj"
                                              filterBy="shortName"
                                              optionLabel="shortName"
                                              placeholder="Seleccione..."
                                              options={props.catBorrower}
                                              value={props.filters.borrowerObj}
                                              onChange={props.saveFilters}
                                    />
                                </div>

                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Flujo" isBold={true}/>
                                    <Dropdown name="flowObj"
                                              filterBy="description"
                                              optionLabel="description"
                                              placeholder="Seleccione..."
                                              options={props.catFlow}
                                              value={props.filters.flowObj}
                                              onChange={props.saveFilters}
                                    />
                                </div>
                                <div className="p-col-12 p-md-3 p-col-3">
                                    <SubtitleLabel header="Fecha Inicio" isBold={true}/>
                                    <Calendar name="concertDate"
                                              locale={CALENDAR_ES}
                                              dateFormat={DATE_FORMAT_CALENDAR}
                                              disabledDays={[0, 6]}
                                              readOnlyInput={true}
                                              monthNavigator={true}
                                              yearNavigator={true}
                                              yearRange={CALENDAR_ES['yearRangeFuture']}
                                              showButtonBar={true}
                                              value={props.filters.concertDate}
                                              onChange={props.saveFilters}
                                              maxDate={props.today}
                                    />
                                </div>

                                <div className="p-col-12 p-md-9 p-col-9">
                                    <br/>
                                    <Button
                                        style={{'float': 'right'}}
                                        label="Limpiar"
                                        className="p-button-secondary"
                                        onClick={props.clearFilters}/>
                                </div>
                            </div>
                        </HeaderScreenPresval>
                    </Grid>
                    <Grid item xs={12} style={{textAlign: 'right'}}>
                        <Typography variant="subtitle2" className={"secondary-text"}>
                            <ContextMenu menuOptions={props.bilateralExportOptions}
                                         isButton={true}
                                         label="Exportar"/>&nbsp;&nbsp;
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            ref={props.controlPanelTable}
                            selectionMode="single"
                            responsive={true}
                            value={props.loanControlPanelList}
                            selection={props.selectedControlPanel}
                            onSelectionChange={props.selectRowControlPanel}
                            onRowDoubleClick={props.onRowDoubleClickControlPanel}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column header=""
                                    body={props.controlPanelTemplate}
                                    style={{textAlign: 'left', width: '3%'}}/>
                            <Column field="id" header="Folio"
                                    style={{textAlign: 'left', width: '5%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="flow" header="Flujo"
                                    style={{textAlign: 'left', width: '6%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="status" header="Estatus"
                                    style={{textAlign: 'left', width: '5%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="instrument" header="Emisora"
                                    style={{textAlign: 'left', width: '10.5%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="title" header="Títulos"
                                    style={{textAlign: 'right', width: '6.5%'}}
                                    body={props.boldAndColorNumberTemplate} sortable={true}/>
                            <Column field="price" header="Precio"
                                    style={{textAlign: 'right', width: '8%'}}
                                    body={props.boldAndColorPriceTemplate} sortable={true}/>
                            <Column field="amount" header="Importe"
                                    style={{textAlign: 'right', width: '10%'}}
                                    body={props.boldAndColorAmountTemplate} sortable={true}/>
                            <Column field="term" header="Plazo"
                                    style={{textAlign: 'right', width: '5%'}}
                                    body={props.boldAndColorNumberTemplate} sortable={true}/>
                            <Column field="rate" header="Tasa"
                                    style={{textAlign: 'right', width: '5%'}}
                                    body={props.boldAndColorRateTemplate} sortable={true}/>
                            <Column field="premium" header="Premio"
                                    style={{textAlign: 'right', width: '6%'}}
                                    body={props.boldAndColorAmountTemplate} sortable={true}/>
                            <Column field="lender" header="Prestamista"
                                    style={{textAlign: 'left', width: '9%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="lenderAccount" header="Cta Ptm"
                                    style={{textAlign: 'left', width: '7%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                            <Column field="borrower" header="Prestatario"
                                    style={{textAlign: 'left', width: '9%'}}
                                    body={props.boldAndColorTextTemplate} sortable={true}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default BilateralControlPanelView;

BilateralControlPanelView.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    messagesGrowl: PropTypes.object.isRequired,
    clearFilters: PropTypes.func.isRequired,
    getControlPanelLoanList: PropTypes.func.isRequired,
    filters: PropTypes.object.isRequired,
    saveFilters: PropTypes.func.isRequired,
    catLender: PropTypes.object.isRequired,
    catBorrower: PropTypes.object.isRequired,
    catFlow: PropTypes.object.isRequired,
    bilateralExportOptions: PropTypes.object.isRequired,
    controlPanelTable: PropTypes.object.isRequired,
    loanControlPanelList: PropTypes.array,
    selectedControlPanel: PropTypes.object.isRequired,
    selectRowControlPanel: PropTypes.func.isRequired,
    onRowDoubleClickControlPanel: PropTypes.func.isRequired,
    controlPanelTemplate: PropTypes.object.isRequired,
    boldAndColorTextTemplate: PropTypes.object.isRequired,
    boldAndColorNumberTemplate: PropTypes.object.isRequired,
    boldAndColorPriceTemplate: PropTypes.object.isRequired,
    boldAndColorAmountTemplate: PropTypes.object.isRequired,
    boldAndColorRateTemplate: PropTypes.object.isRequired,
    today: PropTypes.object
};